// Style constants
export const VSC_BACKGROUND_VAR = "--vscode-sideBar-background";
export const vscBackground = `var(${VSC_BACKGROUND_VAR}, rgb(30 30 30))`;

export const fadeAnimationStyle = `
  @keyframes fadeInUp {
    from { 
      opacity: 0; 
      transform: translateY(20px);
    }
    to { 
      opacity: 1; 
      transform: translateY(0);
    }
  }
  
  @keyframes fadeInStable {
    0% { 
      opacity: 0; 
      transform: translateY(10px);
    }
    100% { 
      opacity: 1; 
      transform: translateY(0);
    }
  }
  
  .animate-fade-in {
    animation: fadeInUp 0.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;
    animation-fill-mode: both;
  }
  
  .animate-fade-in-stable {
    animation: fadeInStable 0.6s ease-out forwards;
    animation-fill-mode: both;
    opacity: 0;
  }
  
  .new-chat-greeting {
    opacity: 0;
    animation: fadeInStable 0.8s ease-out 0.2s forwards;
  }

  .mask-image-bottom {
    -webkit-mask-image: linear-gradient(to bottom, black 70%, transparent 95%);
    mask-image: linear-gradient(to bottom, black 70%, transparent 95%);
    will-change: auto;
  }
`;

export const dragDropAnimationStyle = `
  @keyframes fadeInDropOverlay {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  
  @keyframes fadeOutDropOverlay {
    from { opacity: 1; }
    to { opacity: 0; }
  }
  
  @keyframes threadFadeOut {
    0% { 
      opacity: 1; 
      transform: translateX(0);
    }
    100% { 
      opacity: 0; 
      transform: translateX(-30px);
    }
  }
  
  @keyframes threadFadeIn {
    0% { 
      opacity: 0; 
      transform: translateX(30px);
    }
    100% { 
      opacity: 1; 
      transform: translateX(0);
    }
  }
  
  @keyframes threadSlideOut {
    0% { 
      opacity: 1; 
      transform: translateY(0);
      max-height: 100px;
    }
    100% { 
      opacity: 0; 
      transform: translateY(-15px);
      max-height: 0;
    }
  }
  
  @keyframes threadSlideIn {
    0% { 
      opacity: 0; 
      transform: translateY(15px);
      max-height: 0;
    }
    100% { 
      opacity: 1; 
      transform: translateY(0);
      max-height: 100px;
    }
  }
  
  @keyframes dragGhost {
    0% { 
      opacity: 1; 
    }
    100% { 
      opacity: 0.6; 
    }
  }
  
  .drag-overlay-enter {
    animation: fadeInDropOverlay 150ms ease-in forwards;
  }
  
  .drag-overlay-exit {
    animation: fadeOutDropOverlay 150ms ease-out forwards;
  }
  
  .thread-fade-out {
    animation: threadFadeOut 250ms cubic-bezier(0.22, 1, 0.36, 1) forwards;
  }
  
  .thread-fade-in {
    animation: threadFadeIn 300ms cubic-bezier(0.22, 1, 0.36, 1) forwards;
  }
  
  .thread-slide-out {
    animation: threadSlideOut 200ms cubic-bezier(0.22, 1, 0.36, 1) forwards;
  }
  
  .thread-slide-in {
    animation: threadSlideIn 250ms cubic-bezier(0.22, 1, 0.36, 1) forwards;
  }
  
  .thread-drag-ghost {
    animation: dragGhost 150ms ease-out forwards;
  }
  
  .thread-drag-item {
    transition: transform 0.1s ease, opacity 0.1s ease;
    cursor: pointer;
    -webkit-user-drag: element;
    user-drag: element;
    contain: layout;
  }
  
  .thread-drag-item:hover {
    cursor: grab;
  }
  
  .thread-drag-item.dragging {
    opacity: 0.6;
    z-index: 1000;
    cursor: grabbing !important;
    contain: strict;
  }
  
  .thread-drag-item.moving-out {
    pointer-events: none;
  }
  
  .thread-drag-item.moving-in {
    opacity: 0;
    transform: translateX(30px);
  }
`;
